import { createStyleSheet } from '@shared-ui/theme'

export const useCreateStyles = createStyleSheet(() => ({ icon: { alignItems: 'center', justifyContent: 'center' } }))
